import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Button, Card, Col, Container, Row } from "reactstrap";
import { signInWithGoogle } from "../../store/actions/authAction";
import AuthHeader from "../../components/AuthHeader";

const Login = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { darkMode, color } = useSelector((state) => state.global);

  const isGoogle = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("isGoogle") === "true";
  }, [location.search]);

  useEffect(() => {
    if (isGoogle) {
      dispatch(signInWithGoogle(history, isGoogle));
    }
  }, [dispatch, history, isGoogle]);

  return (
    <div className="auth">
      <Container className="py-5">
        <Row className="d-flex flex-column justify-content-center align-items-center">
          <Col className="mb-5">
            <AuthHeader darkMode={darkMode} title={"NextEats"} />
          </Col>
          <Col className="d-flex mt-5 justify-content-center align-items-center">
            <Card className={darkMode ? "auth__card-dark" : "auth__card"}>
              <Button
                onClick={() => {
                  history.push("/auth");
                }}
                color="primary"
                style={{ background: `${color}` }}
                className={"py-3 mt-2 w-100 auth__btn"}
              >
                Login with email and password
              </Button>
              <Button
                onClick={() => {
                  dispatch(signInWithGoogle(history, isGoogle));
                }}
                color="primary"
                style={{ background: `${color}` }}
                className={`py-3 mt-2 w-100 auth__btn`}
              >
                Login with google
              </Button>
              <Button
                onClick={() => {
                  history.push("/phone-auth");
                }}
                color="primary"
                style={{ background: `${color}` }}
                className={`py-3 mt-2 w-100 auth__btn`}
              >
                Login with phone number
              </Button>
              <Button
                onClick={() => {
                  history.push("/restaurants");
                }}
                color="primary"
                style={{ background: `${color}` }}
                className={`py-3 mt-2 w-100 auth__btn`}
              >
                Continue as a Guest User
              </Button>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
